var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},_vm._l((_vm.content),function(item){return _c('li',{key:item.id,staticClass:"flex project justify-between p-4",class:{
				selected: _vm.selectedItem && _vm.selectedItem.id === item.id,
			},on:{"click":function($event){return _vm.selectItem(item)}}},[_c('p',{staticClass:"project__title"},[_vm._v(" "+_vm._s(item.name)+" "),_c('sup',{staticClass:"project__type"},[_vm._v(_vm._s(item.category))])]),_c('div',{staticClass:"ml-2 arrow",class:{
					arrow__blue:
						_vm.selectedItem && _vm.selectedItem.id === item.id,
				}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }